module.exports = __webpack_public_path__ + "img/9791170281559.f9b6282c.jpg";